<div class="u-checkbox {{ styleClass() }}">
  @if (fieldFormControl()) {
    <mat-checkbox
      class="u-checkbox-item"
      [disabled]="stateElement() === 'disabled'"
      [value]="value()"
      (change)="onCheckboxChange($event)"
      (click)="onCheckboxClick($event)"
      [formControl]="fieldFormControl()"
    >
      {{ label() }}
    </mat-checkbox>
  } @else {
    <mat-checkbox
      class="u-checkbox-item"
      [checked]="isChecked()"
      [disabled]="stateElement() === 'disabled'"
      [value]="value()"
      (change)="onCheckboxChange($event)"
      (click)="onCheckboxClick($event)"
    >
      {{ label() }}
    </mat-checkbox>
  }
</div>
